<template>
    <div class="upc-download-modal">
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s" id="UPC">UPC</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body">
                <div id="upcImage" class="mt-2 upcImage">
                    <img :ref="upcImage" :src="url" />
                </div>
                <RothcoCta type="button" class="primary" id="submitButton" @click="download">
                    Download UPC
                </RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, watch, inject } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";

    const dialogRef = inject("dialogRef");
    let route = inject("route");
    let url = ref("");
    let upc = computed(()=>{
        return dialogRef.value?.data?.upc;
    })
    let upcImage = ref();

    let download = async function () {
        let data = await fetch(
            route("barcode.download", { upc: upc.value })
        ).then((response) => {
            return response.blob();
        });

        //download blob image
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `upc-${upc.value}.png`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const closeDialog = function () {
        dialogRef.value?.close?.();
    };

    watch(
        () => upc.value,
        (newVal, oldVal) => {
            if (newVal !== oldVal && newVal !== "") {
                fetch(route("barcode.show", { upc: upc.value }))
                    .then((response) => {
                        return response.text();
                    })
                    .then((data) => {
                        let base64 = data;
                        url.value = `data:image/png;base64,${base64}`;
                    });
            } else {
                url.value = "";
            }
        }, { immediate: true }
    );
</script>
